import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type AdminPersistence } from '../../../../types/persistence/admin-persistence'

const createAdmin = async (data: AdminPersistence) => {
  const response = await api.post('/admins', data)
  return response.data
}

export const useCreateAdminMutation = () => {
  return useMutation('create-admin', (data: AdminPersistence) => (
    createAdmin(data)
  ))
}
